export default __webpack_public_path__ + "static/media/digital-skills-training-banner-june-12-2025.1d1e6968.jpeg";